/**
 * The input of a form, found by its `name`.
 *
 * A form here reads its inputs by name, never by position. `form.current[11]`
 * read the second password as the city when an input above it went away
 * (admin#86). See positional-form-reads.json and eslint.config.mjs.
 *
 * It returns null for a name that the form does not have, so that a typo
 * fails at once with an error, not with a wrong value.
 *
 * @param {HTMLFormElement | null | undefined} form
 * @param {string} name
 * @returns {HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | null}
 */
// `form.elements.namedItem(name)` also matches an `id`. A form here can give
// the same `controlId` («name», «status») to several groups, so the name
// attribute alone decides.
export const fieldOf = (form, name) => form?.querySelector(`[name="${name}"]`) ?? null;
